import { useMemo } from "react";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";

/** The workspace custom-field pool minus the fields already on the issue —
 *  what the add-field pickers offer. */
export function useAvailableCustomFields(existingFieldIds: string[]) {
  const { customFields: fields } = useWorkspaceData();

  return useMemo(() => {
    const existingSet = new Set(existingFieldIds);
    return fields.filter((field) => !existingSet.has(field.customFieldId));
  }, [fields, existingFieldIds]);
}
